import React from "react";
import "./AIPodcastSection.css";
import { useTranslation } from "react-i18next";
import {
  Github,
  Youtube,
  FileText,
  BookOpen,
  Library,
  Podcast,
  FileCode,
  Newspaper,
  Sparkles,
} from "lucide-react";

export default function AIPodcastSection() {
  const { t } = useTranslation();

  const cards = [
    {
      icon: <Github size={22} />,
      title: t("home.aiPodcast.cards.0.title"),
      desc: t("home.aiPodcast.cards.0.desc"),
      color: "icon-github",
    },
    {
      icon: <Youtube size={22} />,
      title: t("home.aiPodcast.cards.1.title"),
      desc: t("home.aiPodcast.cards.1.desc"),
      color: "icon-youtube",
    },
    {
      icon: <FileText size={22} />,
      title: t("home.aiPodcast.cards.2.title"),
      desc: t("home.aiPodcast.cards.2.desc"),
      color: "icon-research",
    },
    {
      icon: <BookOpen size={22} />,
      title: t("home.aiPodcast.cards.3.title"),
      desc: t("home.aiPodcast.cards.3.desc"),
      color: "icon-docs",
    },
    {
      icon: <Library size={22} />,
      title: t("home.aiPodcast.cards.4.title"),
      desc: t("home.aiPodcast.cards.4.desc"),
      color: "icon-wiki",
    },
    {
      icon: <Podcast size={22} />,
      title: t("home.aiPodcast.cards.5.title"),
      desc: t("home.aiPodcast.cards.5.desc"),
      color: "icon-talks",
    },
    {
      icon: <FileCode size={22} />,
      title: t("home.aiPodcast.cards.6.title"),
      desc: t("home.aiPodcast.cards.6.desc"),
      color: "icon-blogs",
    },
    {
      icon: <Newspaper size={22} />,
      title: t("home.aiPodcast.cards.7.title"),
      desc: t("home.aiPodcast.cards.7.desc"),
      color: "icon-news",
    },
  ];

  const handleStartPodcast = () => {
    window.open("https://podcaststudio.nxnearby.com/", "_blank");
  };

  return (
    <section className="ai-podcast-section">
      <div className="ai-inner">
        <div className="ai-header">
          <div className="ai-pill">
            <Sparkles size={16} className="ai-pill-sparkles" />
            <span>{t("home.aiPodcast.pill")}</span>
          </div>

          <h2 className="ai-title">
            {t("home.aiPodcast.titleBefore")}{" "}
            <span>{t("home.aiPodcast.titleGradient")}</span>{" "}
            {t("home.aiPodcast.titleAfter")}
          </h2>

          <p className="ai-sub">
            {t("home.aiPodcast.sub")}
          </p>
        </div>

        <div className="ai-card-grid">
          {cards.map((card, i) => (
            <div key={i} className="ai-card">
              <div className={`ai-card-icon ${card.color}`}>{card.icon}</div>
              <h4>{card.title}</h4>
              <p>{card.desc}</p>
            </div>
          ))}
        </div>

        <div className="ai-cta-wrapper">
          <button className="ai-start-btn" onClick={handleStartPodcast}>
            <span className="btn-ico">
              <Sparkles size={20} />
            </span>
            {t("home.aiPodcast.cta")}
            <span className="btn-arrow" aria-hidden="true">
              <img src="/Image/Hero/right-arrow.svg" alt="" />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
